import React from "react";
import WPHeader from "../WPHeader/WPHeader";
import WPFooter from "../WPFooter/WPFooter";
import "./WPLayout.css";

interface WPLayoutProps {
  children: React.ReactNode;
}

const WPLayout: React.FC<WPLayoutProps> = ({ children }) => {
  return (
    <div className="wp-layout">
      <WPHeader />
      <main className="wp-layout__content">{children}</main>
      <WPFooter />
    </div>
  );
};

export default WPLayout;
